/**
* Referral System Drawer
*/
class ReferralDrawer extends HTMLElement {
  constructor() {
      super();
  
      this.openBy = document.querySelector('.open-referral-drawer');
      this.closeBy = this.querySelector('.close-referral-drawer');
      this.refDrawer = this;
      this.refOverlay = document.querySelector('.referral-drawer__overlay');
      this.searchInput = this.querySelector("#referral-search");
      this.searchResults = this.querySelector(".referral-drawer__results");
      this.selectedSalon = null;
      this.salonData = this.loadSalonData();

      const storedSalon = localStorage.getItem('selectedSalon');
      
      if (storedSalon) {
          this.selectedSalon = JSON.parse(storedSalon);
          this.searchInput.value = this.selectedSalon.name;
          this.renderResults(this.salonData.filter(salon => salon.id == this.selectedSalon.id));
          this.checkCartAttributes();
          this.updateTrigger(this.selectedSalon.name);
      }

      this.bindEvents();
  }

  /**
 * Load JSON Data from <script type="application/json">
 */
  loadSalonData() {
      try {
          const scriptTag = this.querySelector("#salon-data");
          return JSON.parse(scriptTag.textContent).salons;
      } catch (error) {
          console.error("Error parsing salon JSON data:", error);
          return [];
      }
  }

  /**
  * Check cart attributes for selected salon
  */
  async checkCartAttributes() {
      const cartAttributes = await fetch('/cart.js')
          .then(response => response.json())
          .then(data => data.attributes);
      if (cartAttributes && !cartAttributes.referral_salon) {
        let attributes = {
          "referral_salon": this.selectedSalon.id
        }
        try {
          await this.updateCart(attributes);
        } catch (error) {
          console.error("Error submitting salon:", error);
        }
      } else {
        console.log("Selected salon found in cart attributes:", cartAttributes.referral_salon);
      }
  }

  /**
   * Focus Out Event to close drawer
   *
   * @param {event} Event instance
   */
  focusOut(event){
    let isOpen = this.refDrawer.getAttribute('open') === "true";
    if (!this.refDrawer.contains(event.relatedTarget) && isOpen) {      
      this.closeBy.dispatchEvent(new Event('click'));
    }
  }

  /**
   * Escape Key Press to close drawer when focus is within the container
   *
   * @param {event} Event instance
   */
  onKeyUp(event) {
    if(!event.code || event.code.toUpperCase() !== 'ESCAPE') return;
    this.closeBy.dispatchEvent(new Event('click'));
  }

  /**
   * bind click event to Menu Icon 
   * bind keyup event to Menu Drawer component
   */
  bindEvents() {
      this.openBy.addEventListener('click', this.openRefDrawer.bind(this));
      this.closeBy.addEventListener('click', this.closeRefDrawer.bind(this));
      this.searchInput.addEventListener("input", this.handleSearch.bind(this));
      this.refOverlay.addEventListener('click', this.closeRefDrawer.bind(this));
      this.addEventListener('keyup', this.onKeyUp.bind(this));
      this.addEventListener('focusout', this.focusOut.bind(this));
  }

  /**
   * Handle Search Input - Filters Metaobjects Data
   */

  handleSearch(event) {
      const query = event.target.value.trim().toLowerCase();
      
      this.searchResults.innerHTML = ""; // Clear old results
              
      if (query.length < 2) return; // Avoid unnecessary searches
  
      const filteredResults = this.salonData.filter((salon) =>
          salon.name?.toLowerCase().includes(query) ||
          salon.address?.toLowerCase().includes(query) || 
          salon.country?.toLowerCase().includes(query) ||
          salon.city?.toLowerCase().includes(query) ||
          salon.county?.toLowerCase().includes(query) || 
          salon.postcode?.toLowerCase().includes(query)
      );
  
      this.renderResults(filteredResults);
  }

  /**
   * Select a Salon from Search Results
  */
  selectSalon(element) {
      this.selectedSalon = {
        id: element.dataset.id,
        name: element.dataset.name
      };

      localStorage.setItem('selectedSalon', JSON.stringify(this.selectedSalon));
      this.updateTrigger(this.selectedSalon.name);

      // Display selected salon inside the drawer
      this.searchInput.value = this.selectedSalon.name;

      if (document.querySelector(".referral-location.selected")) {
        document.querySelector(".referral-location.selected").classList.remove("selected");
      }

      element.classList.add("selected");
      //this.searchResults.innerHTML = ""; // Hide suggestions
      this.handleSubmit();
  }

  /**
   * Remove selection
  */
  async removeSelection(element) {
    this.selectedSalon = {};
    localStorage.removeItem('selectedSalon');
    this.updateTrigger(false);

    // Display selected salon inside the drawer
    element.classList.remove("selected");
    //this.searchResults.innerHTML = ""; // Hide suggestions

    this.searchInput.value = "";
    this.searchResults.innerHTML = "";

    let attributes = {
      "referral_salon": null
    }

    try {
      await this.updateCart(attributes);
    } catch (error) {
      console.error("Error deselecting salon:", error);
    }
  }

  /**
 * Submit Selected Salon as Cart Attribute
 */
  async handleSubmit(event) {

    if (event) {
      event.preventDefault();
    }

    if (!this.selectedSalon) {
      return;
    }

    let attributes = {
      "referral_salon": this.selectedSalon.id
    }

    try {
      await this.updateCart(attributes);
    } catch (error) {
      console.error("Error submitting salon:", error);
    }
  }
  
  updateTrigger(storedSalon){
    let salonDrawerTrigger = document.querySelector('.open-referral-container');
    if (storedSalon) {
        salonDrawerTrigger.querySelector('span').innerText = storedSalon;
        salonDrawerTrigger.querySelector('a').innerText = "Change selection";
    } else {
        salonDrawerTrigger.querySelector('span').innerText = "";
        salonDrawerTrigger.querySelector('a').innerText = "Select your salon or clinic";
    }
  }

  /**
   * Render Search Results in the Drawer
   */
  renderResults(results) {

      if (!results.length) {
          this.searchResults.innerHTML = "<p>No results found.</p>";
          return;
      }

      this.searchResults.innerHTML = results
      .map(
          (salon) => `
          <div class="referral-location ${this.selectedSalon && salon.id == this.selectedSalon.id ? 'selected' : ''}" data-id="${salon.id}" data-name="${salon.name}">
            <div class="referral-location__title">
              ${salon.name ? `<h4>${salon.name}</h4>` : ""}
              <button class="referral-location__remove">Deselect location</button>
            </div>
            <div class="referral-location__content">
              <div class="referral-location__address">
                ${salon.address ? `${salon.address}` : ""}
              </div>
              <button class="referral-location__selector">
                Set as prefered location
              </button>
            </div>
            <div class="referral-location__bottom">
              <p>This location will receive a commission on your future purchases.</p>
            </div>
          </div>`
      ).join("");

      // Bind click event to select a salon
      this.searchResults.querySelectorAll(".referral-location").forEach((item) => {
        item.querySelector(".referral-location__selector")?.addEventListener("click", () => this.selectSalon(item));
        item.querySelector(".referral-location__remove")?.addEventListener("click", () => this.removeSelection(item));
      });
  }

  /**
   * Open Menu Drawer
   *
   * @param {event} Event instance
   */

  openRefDrawer(event) {
    this.refDrawer.setAttribute('open', true);
    this.refOverlay.classList.add('active');
    if(event){
      event.preventDefault();
      let openBy = event.currentTarget;
      openBy.setAttribute('aria-expanded', true);
      // Utility.trapFocus(this.refDrawer, this.querySelector('#referral-search'));
      // Utility.forceFocus(this.querySelector('#referral-search'));
    }
  }

  /**
   * Close Menu Drawer
   *
   * @param {event} Event instance
   */
  closeRefDrawer(event, elementToFocus = false) {      
    if (event) {
      event.preventDefault();
      this.refDrawer.removeAttribute('open');
      this.refOverlay.classList.remove('active');

      this.openBy.setAttribute('aria-expanded', false);
      // Utility.forceFocus(this.openBy);
    } else {
      this.closeBy.dispatchEvent(new Event('click'));
    }
  }

  async updateCart(attributes) {
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          attributes: attributes
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    } catch (error) {
      console.error("Error updating cart:", error);
    }
  }
}

customElements.define("referral-drawer", ReferralDrawer);